import { Create, SimpleForm } from "react-admin";

import MiqaatFormFields, { transformMiqaatPayload, validateMiqaatForm } from "./MiqaatFormFields";

export default function MiqaatCreate() {
  return (
    <Create redirect="list" transform={transformMiqaatPayload}>
      <SimpleForm
        warnWhenUnsavedChanges
        validate={validateMiqaatForm}
        sx={{ maxWidth: 640 }}
        defaultValues={{
          dateMode: "TEMPORARY",
          mealType: "LUNCH",
          startTime: "13:30",
          rsvpClosesHoursBeforeEvent: 6,
          selfCheckInEnabled: false,
          selfCheckInOpensHoursBeforeEvent: 0,
          familySelfCheckInEnabled: false,
        }}
      >
        <MiqaatFormFields />
      </SimpleForm>
    </Create>
  );
}
